export class Info {
  status: string;
  pin_number: string;
  transaction_id: string;
  reg_date: Date;
  end_date: Date;
  start_worker_id: string;
  start_worker_type: string;
  end_worker_id: string;
  end_worker_type: string;
  approve_date: string;
  approved_rate: number;
  transaction_reason: string = '';
  sourceOfIncome: string = '';
  relationshipToBeneficiary: string = '';
  timeStamp: string;
}



// WEBPACK FOOTER //
// ./src/app/model/shared/transaction/info.ts